/* src/app/components/processing/platform-activity/services-table/services-table.component.scss */
@keyframes subtleZoom {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.95);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes shimmer {
  from {
    background-position: 150% 0;
  }
  to {
    background-position: -150% 0;
  }
}
:host {
  height: 100%;
}
.primary-icon {
  color: #243e90;
}
.success-icon {
  color: #30a103;
}
.warn-icon {
  color: #cdba00;
}
.critical-icon {
  color: #ba001a;
}
.aws-icon {
  color: #f90;
}
.activity-badge {
  display: flex;
  gap: 3px;
  justify-content: space-between;
  min-width: 85px;
  align-items: center;
  background: #464646;
  color: white;
  padding: 5px 11px 5px 6px;
  border-radius: 30px;
  transition: color 50ms ease-in-out;
}
.activity-badge.active {
  color: #0db700;
}
.activity-badge.container-burst {
  background-color: #464646;
  background-image:
    linear-gradient(
      90deg,
      transparent 30%,
      rgba(248, 4, 4, 0.4) 50%,
      transparent 31%);
  background-size: 300% 100%;
  animation: shimmer 2s infinite linear;
}
.activity-badge.container-burst .fa-fire {
  animation: subtleZoom 1s infinite ease-in-out;
  color: #ff571d;
}
.mat-mdc-header-row > td {
  padding-bottom: 10em;
}
.status-icon-wrapper {
  display: flex;
  width: 20px;
  justify-content: center;
  align-items: center;
}
td {
  background: #FFF;
  font-size: 16px;
  color: #000;
  border: 0;
  height: 55px;
  transition: background-color 250ms ease-in-out;
}
td.active {
  background: rgba(126, 225, 0, 0.0588235294);
}
td.mat-mdc-cell {
  border: none;
}
.mat-mdc-table .mat-mdc-header-cell,
.mat-mdc-table .mat-sort-header {
  background: transparent;
  font-size: 16px;
  --sort-header-color: #000;
  border-bottom: 2px solid #FFC107;
}
.mat-mdc-row {
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.25);
}
tr td:first-child {
  border-left: 2px solid #a1a1a1;
}
tr td {
  transition: background-color 250ms ease-in-out;
}
tr.active td:first-child {
  border-left: 2px solid #0db700;
}
tr.active td {
  background: #ecffec;
}
tr.active.container-burst td:first-child {
  border-left: 2px solid #ff571d;
}
tr.active.container-burst td {
  background: rgba(205, 51, 1, 0.29);
}
:host-context(.dark-theme) th {
  border-bottom: 1px solid #d4a20e;
}
:host-context(.dark-theme) .primary-icon {
  color: #d4a20e;
}
:host-context(.dark-theme) tr td {
  transition: background-color 250ms ease-in-out;
}
:host-context(.dark-theme) tr.active td:first-child {
  border-left: 2px solid #0db700;
}
:host-context(.dark-theme) tr.active td {
  background: #2d402a;
}
:host-context(.dark-theme) tr.active.container-burst td:first-child {
  border-left: 2px solid #ff571d;
}
:host-context(.dark-theme) tr.active.container-burst td {
  background: rgba(205, 51, 1, 0.29);
}
:host-context(.dark-theme) .activity-badge {
  background: #000008;
  color: white;
}
:host-context(.dark-theme) .activity-badge.active {
  color: #0db700;
}
:host-context(.dark-theme) .activity-badge.container-burst {
  background-color: #000000;
  background-image:
    linear-gradient(
      90deg,
      transparent 30%,
      rgba(248, 4, 4, 0.4) 50%,
      transparent 31%);
  background-size: 300% 100%;
}
:host-context(.dark-theme) td {
  background-color: #363636;
}
/*# sourceMappingURL=services-table.component.css.map */
